import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../../../api";
import { OrgInvitationCreate } from "../../../generated/core-api";

/**
 * Hook for creating organization invitations
 */
export function useCreateOrgInvitation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (invitation: OrgInvitationCreate) => {
      return await api.createInvitation(invitation);
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: [
          "orgs",
          variables.org_category,
          variables.org_id,
          "invitations",
        ],
      });
    },
  });
}
